/** Characters */
const maxChar = (char: number | string) =>
  `Max ${char} characters are acceptable`;
const minChar = (char: number | string) =>
  `Min ${char} characters are acceptable`;

/** Numbers */
const maxDigit = (digit: number | string) =>
  `Max ${digit} digits are acceptable`;
const minDigit = (digit: number | string) =>
  `Min ${digit} digits are acceptable`;
const equalOrGrater = (digit: number | string) =>
  `Should be equal or greater than ${digit}`;
const equalOrLess = (digit: number | string) =>
  `Should be equal or less than ${digit}`;

/** file */
const maxFileSize = (size: number | string) =>
  `Max file size acceptable is ${size}MB`;

const MESSAGE = {
  minChar: (char: number | string) => minChar(char),
  maxChar: (char: number | string) => maxChar(char),
  exactChar: (char: number | string) => `Exactly ${char} characters required`,

  minDigit: (digit: number | string) => minDigit(digit),
  maxDigit: (digit: number | string) => maxDigit(digit),
  exactDigit: (digit: number | string) => `Only ${digit} digits are acceptable`,
  equalOrLess: (digit: number | string) => equalOrLess(digit),
  equalOrGrater: (digit: number | string) => equalOrGrater(digit),
  atLeastOneNumber: (field = "") =>
    `${field ? field : "This"} field should consists of at least one number`,
  onlyPositiveNumbers: `Only positive integers are allowed`,
  greaterThanZero: `Should be greater than zero`,
  noZeroAtStart: (msg: string) => `${msg} should not start with zero`,

  maxFileSize: (size: number | string) => maxFileSize(size),
  fileType: (types: string) => `Only ${types} files are acceptable`,

  required: `This field is required`,
  requiredField: (field?: string) =>
    `${field ? field : "This"} field is required`,
  invalidEmail: `Entered email id is incorrect`,
  invalidURL: `Invalid URL`,

  noWhiteSpace: (field = "") =>
    `Blank spaces ${field && `in ${field}`} is not accepted`,

  passwordMisMatch: `Password doesn't match`,
  passwordLength: `Password should consists of at least 6 characters`,
  passwordCurrentNotMatch: `Current password does not match`,

  /*****/
  emailSend: `Email has been sent, please check your inbox`,
  passwordResetSuccess: `Your password has been re-set successfully`,
  passwordResetFail: `Password reset failed, please try again`,
  passwordUpdateSuccess: `Your password has been updated successfully`,
  passwordUpdateFail: `Password update failed, please try again`,

  updateSuccess: (field: string) => `${field} updated successfully`,

  invalidDate: `Invalid End Date Format`,
  dateLessThanBefore: `Date should not be before start date`,

  somethingWrong: (operation?: string) =>
    `Something went wrong ${
      operation ? `while ${operation}` : ""
    }, please try again`,

  emoji: `Emoji is not acceptable`,
  brandDataMissing: `Not getting brand data, please contact to admin`,

  /** Creative feedback */
  invalidCreativeName: `Maximum characters accepted for Creative Name are 50.`,
  invalidCreativeFeedback: `Maximum characters accepted for Description/Change required are 200.`,

  /** Budget plan */
  presetBudgetSumInvalid: (presetTotal: number | string) =>
    `The sum of distributed budget among the selected location must be equal to the pre-set total of $${presetTotal}`,
  budgetNotSet: `Please plan your budget`,
  locationSpecificBudgetInvalid: (
    min_budget: number | string,
    max_budget: number | string
  ) =>
    `Please set individual location budget between $${min_budget} and $${max_budget}`,
  locationBudgetZero: `Location budget can not be zero`,
};

export default MESSAGE;
